import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { verifyToken } from "./Services/authService";

const PrivateRoute = () => {
  const [isTokenValid, setIsTokenValid] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const hash = location.hash; 
  const id = hash.split('/').pop();

  useEffect(() => {
    const fetchToken = async () => {
      try {

        const fetchedToken = await verifyToken();

        setIsTokenValid(fetchedToken.success);
      } catch (error) {
        setIsTokenValid(null);
      } finally {
        setLoading(false); // Stop loading after fetching
      }
    };
    fetchToken();
  }, []); // Run only once on mount

  if (loading) {
    return <div></div>; // Provide loading feedback
  }
  if (isTokenValid) {
    return <Outlet />;
  } else {
    return location.hash.startsWith('#/reset_password') 
      ? <Navigate to={`/reset_password/${id}`} /> 
      : <Navigate to="/login" />;
  }
};

export default PrivateRoute;
